import React from "react";
import { Container } from "react-bootstrap";
import { LANES } from "../../data/career-lanes";
import CareerLane from "../paths/CareerLane";
import {
  Section,
  SectionLabel,
  SectionTitle,
  SectionDesc,
} from "./CareerPath.styles";

const LaneViewer = () => (
  <Section>
    <Container>
      <SectionLabel>PROGRESSION</SectionLabel>
      <SectionTitle>Where you are. Where you're going.</SectionTitle>
      <SectionDesc>
        Click any role to see what it takes. Tracks are not silos — you can jump
        from DevOps to SRE at the same level. Your tools change, your judgment doesn't.
      </SectionDesc>

      {LANES.map((lane) => (
        <CareerLane key={lane.key} lane={lane} />
      ))}
    </Container>
  </Section>
);

export default LaneViewer;
